
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import CharterYachtComponent from "@/components/YachtComponent/CharterYachtComponent.vue";
import {useWindowSize} from "@vueuse/core";
import {computed} from "vue";
import {useYachtStore} from "@/stores/yachtStore.js";

defineEmits(["close"]);

const props = defineProps({
  yachts: {
    type: Array,
    required: true,
  },
});

const { width } = useWindowSize();
const isMobileSmall = computed(() => width.value < 1024);
const yachtStore = useYachtStore();

</script>

<template>

  <div :class="['relative ',
  yachts.length === 1 ? 'sm:w-1/2 sm:place-self-center' : '',

  ]" @click.stop>
    <!-- Swiper -->

    <Swiper
        :modules="[Navigation]"
        :slides-per-view="isMobileSmall || yachts.length === 1 ? 1 : 2"
        :space-between="10"
        :loop="true"
        :navigation="yachts.length !== 1"
        :speed="800"
        class="h-auto"
    >

      <SwiperSlide v-for="(yacht, index) in yachts" :key="`swiper-${index}-${yacht.id}`">
        <div class="w-full pt-20 h-auto px-4 box-border">
          <div class="overflow-hidden bg-white">
            <CharterYachtComponent
                :index="index"
                :yacht="yacht"
                @on-view-details-click="yachtStore.viewYachtDetails(yacht.slug)"
            />
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  </div>
</template>


<style scoped>

:deep(.swiper-backface-hidden) {
  backface-visibility: visible !important;
  transform: none !important;
}

:deep(.swiper-pagination-bullet-active) {
  background: #691736 !important;
  transform: scale(1.2);
}

:deep(.swiper-slide) {
  height: auto !important;
  overflow: visible;
  transition: opacity 0.3s ease;
}


:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  width: 50px;
  height: 50px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 2px rgba(105, 23, 54, 0.5);
  transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;
}


:deep(.swiper-button-prev:hover),
:deep(.swiper-button-next:hover) {
  background-color: #beA5aa;
}

:deep(.swiper-button-prev:after),
:deep(.swiper-button-next:after) {
  font-size: 20px;
  color: #691736;
}

:deep(.swiper-button-prev) {
  left: 20px;
}

:deep(.swiper-button-next) {
  right: 20px;
}

</style>
